var render, staticRenderFns
import script from "./AxDate.vue?vue&type=script&lang=ts&"
export * from "./AxDate.vue?vue&type=script&lang=ts&"
import style0 from "./AxDate.vue?vue&type=style&index=0&id=311f02b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports